(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-actions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('.off-close')) return;
    const offBtn = event.target.closest('.off-btn');
    if (!offBtn) return;
    event.preventDefault();
    // Trigger Klaviyo's own (off-screen) teaser rather than a hard-coded form
    // ID — Klaviyo reassigns the ID whenever the form is recreated, so clicking
    // the real teaser keeps this working no matter which form is live.
    const teaser = document.querySelector('[class*="kl-teaser"]');
    const trigger = teaser && (teaser.querySelector('button, a, [role="button"]') || teaser);
    if (trigger) trigger.click();
  });

  // 15% off tab dismissal (mobile only shows the close button). Hidden by
  // default via CSS; JS reveals it unless it was dismissed within the last day.
  const OFF_DISMISSED_KEY = 'ptaOffDismissedAt';
  const OFF_DISMISS_MS = 24 * 60 * 60 * 1000; // 1 day
  function offDismissed() {
    try {
      const ts = parseInt(localStorage.getItem(OFF_DISMISSED_KEY), 10);
      return !!ts && (Date.now() - ts) < OFF_DISMISS_MS;
    } catch (e) {
      return false;
    }
  }
  function refreshOffVisibility() {
    const show = !offDismissed() && !!document.querySelector('[class*="kl-teaser"]');
    document.querySelectorAll('.off-btn').forEach(function (el) {
      el.classList.toggle('off-visible', show);
    });
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.off-close')) return;
    event.preventDefault();
    try { localStorage.setItem(OFF_DISMISSED_KEY, Date.now()); } catch (e) {}
    refreshOffVisibility();
  });
  refreshOffVisibility();
  new MutationObserver(refreshOffVisibility).observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Resolve once the Gorgias Chat API is loaded AND initialized — its methods
  // (open/isOpen/isBusinessHours) throw if called before init(). Both the event
  // listener and the poll are needed: 'gorgias-widget-loaded' may have already
  // fired before this script runs (common on heavier pages like the PDP)
  let gorgiasReady;
  let gorgiasInitialized = false;
  function whenGorgiasReady() {
    if (gorgiasReady) return gorgiasReady;
    gorgiasReady = new Promise(function (resolve) {
      let done = false;
      function markReady() {
        gorgiasInitialized = true;
        resolve();
      }
      function init() {
        if (done) return true;
        if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
          done = true;
          Promise.resolve(window.GorgiasChat.init()).then(markReady, markReady);
          return true;
        }
        return false;
      }
      if (init()) return;
      window.addEventListener('gorgias-widget-loaded', init, { once: true });
      let tries = 0;
      const poll = setInterval(function () {
        if (init() || ++tries > 40) clearInterval(poll);
      }, 500);
    });
    return gorgiasReady;
  }

  // Our custom chat icon toggles the Gorgias chat window open/closed
  document.addEventListener('click', function (event) {
    const chatBtn = event.target.closest('.chat-btn, .chat-link');
    if (!chatBtn) return;
    // Menu "Chat Now" links keep their href as a fallback when Gorgias is absent
    if (chatBtn.classList.contains('chat-link') && !document.getElementById('gorgias-chat-container')) return;
    event.preventDefault();
    // Side the window opens on: left under the floating icon, right for menu links
    document.body.classList.toggle('chat-window-right', chatBtn.classList.contains('chat-link'));
    whenGorgiasReady().then(function () {
      const container = document.getElementById('gorgias-chat-container');
      if (container) container.style.display = '';
      const gc = window.GorgiasChat;
      if (!gc) return;
      if (typeof gc.isOpen === 'function' && gc.isOpen()) {
        gc.close();
      } else if (typeof gc.open === 'function') {
        gc.open();
      }
    });
  });

  // Close the chat window when clicking anywhere outside it — clicks inside the
  // Gorgias iframe never reach this document, so only outside clicks get here
  document.addEventListener('click', function (event) {
    if (!gorgiasInitialized) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('.chat-btn, .chat-link, #gorgias-chat-container')) return;
    const gc = window.GorgiasChat;
    if (gc && typeof gc.isOpen === 'function' && gc.isOpen()) gc.close();
  });

  // Open the Accessibly app dialog when the accessibility button is clicked
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.accessibility-btn')) return;
    event.preventDefault();
    var dialog = document.getElementById('accessiblyAppDialogButton');
    if (dialog) dialog.click();
  });

  // Icons are hidden by default; show them whenever Gorgias rendered its widget
  // on this page (container present). We do NOT gate on business hours — outside
  // hours Gorgias still allows leaving a message, so the chat stays usable.
  function refreshChatIconVisibility() {
    const show = !!document.getElementById('gorgias-chat-container');
    document.querySelectorAll('.chat-btn').forEach(function (btn) {
      btn.classList.toggle('is-available', show);
    });
  }
  whenGorgiasReady().then(refreshChatIconVisibility);
  // Fallback: when Gorgias is suppressed on the page it never initializes, so
  // whenGorgiasReady() stays pending — hide the dead icon after a grace period
  setTimeout(refreshChatIconVisibility, 6000);

  // Klaviyo's close routine crashes before removing its scroll lock (onsite.js
  // event conflict), so release the lock ourselves once the dialog is hidden.
  new MutationObserver(function () {
    if (!document.body.classList.contains('klaviyo-prevent-body-scrolling')) return;
    const dialog = document.querySelector('[data-kl-scroll-locking-modal]');
    if (!dialog) return;
    const dialogWatcher = new MutationObserver(function () {
      if (dialog.style.display === 'none') {
        dialogWatcher.disconnect();
        document.body.classList.remove('klaviyo-prevent-body-scrolling');
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('overflow');
      }
    });
    dialogWatcher.observe(dialog, { attributes: true, attributeFilter: ['style'] });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  } catch(e) { console.error(e); }
})();
})();
